<template>
  <base-container
    :fluid="true"
    :class="['fp-banner', `fp-banner--${position}`]"
    :style="{ position: fixed ? 'fixed' : 'absolute' }"
  >
    <slot></slot>
    <span @click="$emit('close')" class="fp-banner__close">
      <XMarkSVG />
    </span>
  </base-container>
</template>

<script>
import XMarkSVG from "@/assets/svg/x-mark.svg"
export default {
  props: {
    position: {
      type: String,
      default: "top",
      validator(val) {
        return ["top", "bottom"].indexOf(val) !== -1
      }
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  components: {
    XMarkSVG
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";

.fp-banner {
  min-height: 90px;
  padding: 35px;
  // give enought space to x-mark
  padding-right: 50px;
  background: white;
  z-index: 9;
  left: 0;
  color: $color-accent;
  color: var(--color-accent, $color-accent);
  &--top {
    top: 0;
    border-bottom: 2px solid;
    border-color: $color-accent;
    border-color: var(--color-accent, $color-accent);
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.16);
  }
  &--bottom {
    bottom: 0;
    border-top: 2px solid;
    border-color: $color-accent;
    border-color: var(--color-accent, $color-accent);
  }
  &__close {
    right: 35px;
    top: 35px;
    cursor: pointer;
    position: absolute;
    svg {
      stroke: $color-primary--dark;
      stroke: var(--color-primary--dark, $color-primary--dark);
    }
  }
}
</style>
